import * as ActionTypes from "../action-types";

const vehicleDerivativeLog_defaultState = {
    byID: {},
    logByVID: {},
    allIDs: []
}

export const vehicleDerivativeLogs = (
    state = vehicleDerivativeLog_defaultState,
    action
) => {
    let newState = JSON.parse(JSON.stringify(state));

    if(!action) return newState

    switch (action.type) {
        case ActionTypes.GET_TIMEFRAME_VEHICLE_DERIVATIVE_LOGS: {

            const vehicleDerivativeLogs = action.vehicleDerivativeLogs

            const vid = action.vid
            const startTime = action.startTime
            const endTime = action.endTIme

            newState.byID[vid] = [startTime, endTime]

            newState.logByVID[vid] = vehicleDerivativeLogs.sort((a,b) => a.vehicleTime-b.vehicleTime)
            
            if(!newState.allIDs.includes(vid)) newState.allIDs.push(vid)
            
            return newState;
        }
        default: {
            return state;
        }
    }
};
